import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {SelectBox as DXSelectBox} from 'devextreme-react';


export default class SelectBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            disabled: props.disabled,
            opened: props.opened
        };

        this.onOptionChanged = this.onOptionChanged.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            value: props.value,
            disabled: props.disabled,
        });
    }

    onOptionChanged(e) {
        if (e.name === 'opened') {
            this.setState({opened: !this.state.opened});
        }
    }

    onValueChanged(e) {
        const {setProps} = this.props;
        if (setProps) {
            setProps({
                value: e.value,
                valueChanged: {value: e.value, previousValue: e.previousValue, timestamp: Date.now()}
            });
        }
        this.setState({value: e.value});
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXSelectBox
                {...R.omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                opened={this.state.opened}
                value={this.state.value}
                disabled={this.state.disabled}
                onOptionChanged={this.props.onOptionChanged || this.onOptionChanged}
                onValueChanged={this.props.onValueChanged || this.onValueChanged}
            />
        );
    }
}

SelectBox.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    acceptCustomValue: PropTypes.bool,
    accessKey: PropTypes.string,
    activeStateEnabled: PropTypes.bool,
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.arrayOf(PropTypes.any)]),
    deferRendering: PropTypes.bool,
    disabled: PropTypes.bool,
    displayExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    dropDownButtonTemplate: PropTypes.string,
    elementAttr: PropTypes.object,
    fieldTemplate: PropTypes.string,
    focusStateEnabled: PropTypes.bool,
    grouped: PropTypes.bool,
    groupTemplate: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    hint: PropTypes.string,
    hoverStateEnabled: PropTypes.bool,
    inputAttr: PropTypes.object,
    isValid: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.any),
    itemTemplate: PropTypes.string,
    maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minSearchLength: PropTypes.number,
    name: PropTypes.string,
    noDataText: PropTypes.string,
    onChange: PropTypes.func,
    onClosed: PropTypes.func,
    onContentReady: PropTypes.func,
    onCopy: PropTypes.func,
    onCustomItemCreating: PropTypes.func,
    onCut: PropTypes.func,
    onDisposing: PropTypes.func,
    onEnterKey: PropTypes.func,
    onFocusIn: PropTypes.func,
    onFocusOut: PropTypes.func,
    onInitialized: PropTypes.func,
    onInput: PropTypes.func,
    onItemClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyUp: PropTypes.func,
    onOpened: PropTypes.func,
    onOptionChanged: PropTypes.func,
    onPaste: PropTypes.func,
    onSelectionChanged: PropTypes.func,
    onValueChanged: PropTypes.func,
    opened: PropTypes.bool,
    openOnFieldClick: PropTypes.bool,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    rtlEnabled: PropTypes.bool,
    searchEnabled: PropTypes.bool,
    searchExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    searchMode: PropTypes.oneOf(['contains', 'startswith']),
    searchTimeout: PropTypes.number,
    showClearButton: PropTypes.bool,
    showDataBeforeSearch: PropTypes.bool,
    showDropDownButton: PropTypes.bool,
    showSelectionControls: PropTypes.bool,
    spellcheck: PropTypes.bool,
    stylingMode: PropTypes.oneOf(['outlined', 'underlined', 'filled']),
    tabIndex: PropTypes.number,
    validationError: PropTypes.object,
    validationMessageMode: PropTypes.oneOf(['always', 'auto']),
    value: PropTypes.any,
    valueChangeEvent: PropTypes.string,
    /**
     * Dash event
     */
    valueChanged: PropTypes.object,
    valueExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

SelectBox.defaultProps = {
    acceptCustomValue: false,
    accessKey: null,
    activeStateEnabled: true,
    dataSource: null,
    deferRendering: true,
    disabled: false,
    // displayExpr: undefined,
    dropDownButtonTemplate: 'dropDownButton',
    elementAttr: {},
    fieldTemplate: null,
    focusStateEnabled: true,
    grouped: false,
    groupTemplate: 'group',
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: true,
    inputAttr: {},
    isValid: true,
    items: null,
    itemTemplate: 'item',
    maxLength: null,
    minSearchLength: 0,
    name: '',
    noDataText: 'No data to display',
    onChange: null,
    onClosed: null,
    onContentReady: null,
    onCopy: null,
    // onCustomItemCreating: function(e) { if(!e.customItem) { e.customItem = e.text; } },
    onCut: null,
    onDisposing: null,
    onEnterKey: null,
    onFocusIn: null,
    onFocusOut: null,
    onInitialized: null,
    onInput: null,
    onItemClick: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onOpened: null,
    onOptionChanged: null,
    onPaste: null,
    onSelectionChanged: null,
    onValueChanged: null,
    opened: false,
    openOnFieldClick: true,
    placeholder: 'Select',
    readOnly: false,
    rtlEnabled: false,
    searchEnabled: false,
    searchExpr: null,
    searchMode: 'contains',
    searchTimeout: 500,
    showClearButton: false,
    showDataBeforeSearch: false,
    showDropDownButton: true,
    showSelectionControls: false,
    spellcheck: false,
    stylingMode: 'outlined',
    tabIndex: 0,
    // validationError: undefined,
    validationMessageMode: 'auto',
    value: null,
    valueChangeEvent: 'change',
    valueExpr: 'this',
    visible: true,
    // width: undefined
};
